<p class="certificate-status" *ngIf="!toBeAudited && certStatuses && certNames">
    <span class="in-progress" *ngIf="isInProgress"> {{ isDetailsView ? certNames[statusId] : 'In Progress' }} </span>
    <span class="completed" *ngIf="isCompleted"> {{ certNames[statusId] }} </span>
    <span class="disabled" *ngIf="isDisabled"> {{ isDetailsView ? certNames[statusId] : 'Disabled' }} </span>
    <span class="rejected" *ngIf="isRejected"> {{ certNames[statusId] }} </span>
    <span class="archived" *ngIf="isArchived"> {{ certNames[statusId] }} </span>
    <span
        *ngIf="showStatusIcon"
        class="fa fa-question-circle circle-icon"
        [ngbTooltip]="statusTooltipText"
        container="body"
    >
    </span>
    <cm-icon *ngIf="showEditIcon" class="edit-icon" name="edit-circle" [ngbTooltip]="editIconTooltip"> </cm-icon>
</p>
<p class="certificate-status" *ngIf="toBeAudited"><span class="completed">Pending Verification</span></p>
<ng-template #statusTooltipText>
    <p *ngIf="statusId === certStatuses.CREDENTIAL_PAUSED">
        {{ organizationContactData.name }} has paused your credential due to the following reason:
    </p>
    <p [innerHTML]="statusIconTooltip"></p>
    <p>
        Please contact {{ organizationContactData.name }} at {{ organizationContactData.email }} for further
        information.
    </p>
</ng-template>
